import Enums from 'utils/EnumsManager';

const { REPORTS, DROPZONES } = Enums;
const { GROUPSORTER, ORTHERSSORRTER } = REPORTS.SORTER;
const { GROUPS, OTHERS, AGGREGATES } = DROPZONES;

const checkOptionsAvailable = cols => cols && !cols.fieldDeleted && !cols.fieldRestricted;

const parseOptions = (selectedCols) => {
  const options = [];
  selectedCols.forEach(col => {
    if (checkOptionsAvailable(col)) {
      options.push({
        option: col.name,
        type: 'name',
        belongTo: col.belongTo
      });
      if (_.isArray(col.actions)) {
        col.actions.forEach(action => {
          options.push({
            option: action,
            type: 'action',
            belongTo: col.belongTo
          });
        });
      }
      if (_.isString(col.actions)) {
        options.push({
          option: col.actions,
          type: 'action',
          belongTo: col.belongTo
        });
      }
    }
  });
  return options;
};

const resetSorterIfNecessary = (sorter, selectedCols, resetModalSorter) => {
  const options = parseOptions(selectedCols);
  Object.keys(sorter).forEach(key => {
    if (key === GROUPSORTER) {
      const { name, action } = sorter[key].selectedValue;
      const groupOptions = options.filter(option => option.belongTo === GROUPS || option.belongTo === AGGREGATES);
      const groupNotMatch = groupOptions.some(option => option.option === name.value || option.option === action.value);
      if (!groupNotMatch) {
        resetModalSorter();
      }
    }
    if (key === ORTHERSSORRTER) {
      const { name, action } = sorter[key].selectedValue;
      const otherMatch = options.some(option => option.option === name.value || option.option === action.value);
      if (!otherMatch) {
        resetModalSorter();
      }
    }
  });
};

export {
  parseOptions,
  resetSorterIfNecessary,
  checkOptionsAvailable
};



// WEBPACK FOOTER //
// ./src/views/ReportTableSetup/utils/checkReportSorter.js